var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckoutArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44691 8.41298L0.67831 3.32603C-0.0242765 2.70646 -0.181064 1.99755 0.207947 1.19929C0.595479 0.399721 1.28845 -6.10352e-05 2.28686 -6.10352e-05L13.7131 -6.10352e-05C14.7115 -6.10352e-05 15.4045 0.399721 15.7921 1.19929C16.1811 1.99755 16.0243 2.70646 15.3217 3.32603L9.55308 8.41298C9.33121 8.60863 9.09086 8.75537 8.83201 8.8532C8.57316 8.95103 8.29583 8.99994 8 8.99994C7.70417 8.99994 7.42684 8.95103 7.16799 8.8532C6.90914 8.75537 6.66878 8.60863 6.44691 8.41298Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutArrowDown);
export default __webpack_public_path__ + "static/media/checkout-arrow-down.420d7152eba75b254b64b5dcf17718e6.svg";
export { ForwardRef as ReactComponent };